export enum DriversLicense {
  Yes = 'yes',
  No = 'no',
  Learning = 'learning',
  YesWithCar = 'yes_with_car',
}

export const DRIVERS_LICENSE_TRANSLATIONS = {
  [DriversLicense.YesWithCar]: 'Ja und auch ein Auto',
  [DriversLicense.Learning]: 'Noch in der Fahrschule',
  [DriversLicense.No]: 'Nein',
  [DriversLicense.Yes]: 'Ja',
};
